import { isWebview as isWebviewSdk } from '@dvlden/is-webview';

export const isWebview = (): boolean => {
  const isInIframe = window.self !== window.top;
  const isInWebView = isWebviewSdk(window.navigator.userAgent);

  return isInIframe || isInWebView;
};
